<template>
  <AppAuthenticated v-if="!!authorization" :authorization="authorization" />
  <AppDefault v-else />
</template>

<script>
import AppDefault from './AppDefault'
import AppAuthenticated from './AppAuthenticated'
import extractQueryParams from '@/common/utils/extractQueryParams'
import { toCamelCase } from '@/common/lib/case-parser'

export default {
  components: {
    AppAuthenticated,
    AppDefault
  },
  data() {
    return {
      authorization: ''
    }
  },
  created() {
    const { q } = extractQueryParams(document.URL)
    if (!q) {
      return
    }
    const data = toCamelCase(JSON.parse(atob(q)))
    console.log(data)
    if (data.user) {
      this.authorization = data.user
      this.personType = 'PJ'
    }
  }
}
</script>

<style lang="scss">
$fa-font-path: '~/assets/fonts/fontawesome';

@import './assets/scss/main';

button:disabled {
  border-color: #f2f5fa !important;
  background-color: #f2f5fa !important;
  color: #5b5e63;
}
</style>
